import React, { useEffect, useReducer, useRef, useState } from "react";
import style from "./EditPlan.module.sass";
import List from "../List/List";
import ExerciseItem from "./ExerciseItem/ExerciseItem";
import { callApi } from "../../helpers";
import EditPlanSummaryBlock from "./EditPlanSummaryBlock/EditPlanSummaryBlock";
import EditPlanHeader from "./EditPlanHeader/EditPlanHeader";
import { reducer, initState } from "./EditPlanState";
import Button from "../Button/Button";
function EditPlan(props) {
  const {
    addExerciseUrl,
    baseUrl,
    backBtn,
    districtId,
    filtersUrl,
    showBiofeedbackInfo,
    id,
    labelKey,
    showAlert,
    planSummaryUrl,
    showFilters,
    type
  } = props;
  const [translations, setTranslations] = useState(null);
  const [state, dispatcher] = useReducer(reducer, { districtId }, initState);
  const [queryUrl, setQueryUrl] = useState(
    districtId ? baseUrl + "?district_id=" + districtId : baseUrl
  );
  const [isLoading, setIsLoading] = useState(false);
  const editPlanListRef = useRef();

  useEffect(() => {
    getPlanSummary();
    window.addEventListener("resize", onResize.bind(this));
    onResize();
  }, []);

  useEffect(() => {
    onChangeFilter();
  }, [state.district]);

  const onResize = () => {
    const blockBoundingBox = editPlanListRef.current.getBoundingClientRect();
    const newHeight = window.innerHeight - blockBoundingBox.y;
    editPlanListRef.current.style.height = `${newHeight}px`;
  };

  const clickOnAddItem = (exerciseId) => {
    callApi(
      state.addURL,
      "POST",
      "json",
      getPlanSummary,
      getPlanSummary,
      getPlanSummary,
      {
        body: JSON.stringify({
          sequence_id: id,
          district_id: state.district,
          exercise_id: exerciseId,
        }),
      }
    );
  };

  const removeItem = (url) => {
    callApi(url, "DELETE", "", getPlanSummary);
  };

  const getPlanSummary = () => {
    // `/personal_sequence_area/personal_sequences/${id}/personal_sequences_exercises.json}`,
    callApi(planSummaryUrl, "GET", "json", onGetSummary);
  };

  const onGetSummary = (data) => {
    dispatcher({
      type: "update_plan_summary",
      ...data,
    });
  };

  const renderItem = (item) => {
    return (
      <ExerciseItem
        {...item}
        labelKey={labelKey}
        clickOnAdd={clickOnAddItem}
        showBiofeedbackLabel={item.hasBiofeedback && showBiofeedbackInfo}
      />
    )
  };

  const onChangeFilter = (parameters = "") => {
    let newQueryUrl = baseUrl;
    if (parameters) {
      newQueryUrl += "?" + parameters;
      if (state.district) {
        newQueryUrl += "&district_id=" + state.district;
      }
    } else {
      if (state.district) {
        newQueryUrl += "?district_id=" + state.district;
      }
    }
    setIsLoading(true);
    setQueryUrl(newQueryUrl);
  };

  const onItemsLoaded = (items, data) => {
    dispatcher({
      type: "update_add_url",
      addURL: addExerciseUrl,
    });
    dispatcher({
      type: "update_tot_found",
      totFound: data.pagy.count,
    });
    if (!translations) {
      setTranslations(data.translations);
    }
    setIsLoading(false);
    new VideoHandlerObserver(editPlanListRef.current);
    TweenLite.to(editPlanListRef.current, 0.3, { scrollTop: 0 });
  };

  return (
    <div className={`${style.EditPlan}`}>
      <div className={style.title}>
        {
          backBtn &&
          <Button kariBtnWhite href={backBtn.url}>
            {backBtn.label}
          </Button>
        }
        {state.title}
      </div>
      <EditPlanContext.Provider
        value={{ state, dispatcher, removeItem, translations, isLoading }}
      >
        <div className={`${style.EditPlanHeader}`}></div>
        <div className={`${style.EditPlanContent}`}>
          <div className={`${style.EditPlanContentLeft}`}>
            <EditPlanHeader
              onChangeFilter={onChangeFilter}
              id={id}
              district={state.district}
              filtersUrl={filtersUrl}
              showBiofeedbackSwitch={showBiofeedbackInfo}
              translations={translations}
              showFilters={showFilters}
            />
            <div className={`${style.EditPlanContentLeftIn}`}>
              <div
                className={`${style.EditPlanContentLeftInScroll}`}
                ref={editPlanListRef}
              >
                <List
                  baseQuery={queryUrl}
                  renderItem={renderItem}
                  showPagination={true}
                  onItemsLoaded={onItemsLoaded}
                />
              </div>
            </div>
          </div>
          <div className={`${style.EditPlanContentRight}`}>
            <EditPlanSummaryBlock
              nextStep={state.nextStep}
              showAlert={showAlert}
              type={type}
            />
          </div>
        </div>
      </EditPlanContext.Provider>
    </div>
  );
}

EditPlan.propTypes = {};

EditPlan.defaultProps = {
  showFilters: true,
  showBiofeedbackInfo: false,
  showAlert: true
};

export const EditPlanContext = React.createContext({});

export default EditPlan;
